import type { DeleteRecordActionConfig } from '@lighthouse/core'
import { FlowSelectSourceType } from '@lighthouse/core'
import type { FlowNode } from '@lighthouse/shared'
import { fromUpstreamOptions, getUpstreamNodeOption, OUTPUT_RECORD_NODES } from '@lighthouse/shared'
import { useNodesData } from '@xyflow/react'
import React, { useMemo } from 'react'

import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSourceList, useDataSourceOptions } from '@/hooks/useDataSource'

import * as CM from '../styles'
import * as SC from './styles'

type DeleteSingleRecordCardProps = {
    config: DeleteRecordActionConfig
}

const DeleteSingleRecordCard: React.FC<DeleteSingleRecordCardProps> = ({ config }) => {
    const { dataSourceId, selectType, nodeId } = config

    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()
    const dataSourceList = useDataSourceList(appId, envId)

    const nodes = useNodesData([nodeId]) as FlowNode[]

    const upstreamNodesForSource = useMemo(() => nodes?.filter(item => OUTPUT_RECORD_NODES.has(item.data.nodeType)), [nodes])

    const nodeOptions = useMemo(
        () =>
            getUpstreamNodeOption({ allParentNodes: upstreamNodesForSource || [], dataSourceList }).map(v => ({
                ...v,
                icon: typeof v.icon === 'string' ? <SC.Icon type={v.icon} /> : v.icon
            })),
        [dataSourceList, upstreamNodesForSource]
    )

    const options = useDataSourceOptions()

    const option = useMemo(() => {
        if (selectType === FlowSelectSourceType.DATASOURCE) {
            const option = options.find(item => item.value === dataSourceId)
            return { ...option, icon: <SC.Icon type={option?.icon ?? ''} /> }
        } else if (selectType === FlowSelectSourceType.UPSTREAM) {
            return nodeOptions.find(item => item.value === nodeId)
        }
    }, [dataSourceId, nodeId, nodeOptions, options, selectType])

    const nodeTypeName = useMemo(() => {
        const data = fromUpstreamOptions.find(item => item.value === selectType)
        return data?.label
    }, [selectType])

    if (!option) {
        return null
    }

    return (
        <CM.CardItemContainer>
            <SC.TypeName>记录来自-{nodeTypeName}</SC.TypeName>

            <CM.FieldList>
                <CM.FieldItem>
                    <CM.FieldItemLeftFill>
                        {option.icon}
                        <CM.FieldItemTitle>{option?.label}</CM.FieldItemTitle>
                    </CM.FieldItemLeftFill>
                </CM.FieldItem>
            </CM.FieldList>
        </CM.CardItemContainer>
    )
}

export default DeleteSingleRecordCard
